<pfx-panel
  [toggleable]="true"
  [scrollableContent]="true"
>
  <ng-template pfxTemplate="header">
    <div class="flex items-center justify-between">
      <span class="p-panel-title order-none">{{ panelTitle() }}</span>
      <pfx-button
        title="Hinzufügen"
        (clicked)="toggleCreateSidebar()"
      ></pfx-button>
    </div>
  </ng-template>
  <div class="mb-4">
    <pfx-panel-group
      [items]="taskListWidgetStore.renderItems()"
      [clickable]="true"
      (panelClicked)="handlePanelItemClicked($event)"
    >
      <ng-template
        [pfxTemplate]="PanelTemplateType.CONTENT"
        let-details
        let-taskId="id"
      >
        <pfx-task-notes-widget
          [taskId]="taskId"
          [notes]="details"
        ></pfx-task-notes-widget>
      </ng-template>
    </pfx-panel-group>
  </div>

  <div class="text-center">
    <a [routerLink]="[url()]">alle Aufgaben zeigen</a>
  </div>
</pfx-panel>

@if (isCreateSidebarVisible()) {
  <pfx-task-create-sidebar [(visible)]="isCreateSidebarVisible"></pfx-task-create-sidebar>
}

@if (isDetailsSidebarOpen(); as isDetailsSidebarOpen) {
  <pfx-task-details-sidebar
    [visible]="isDetailsSidebarOpen"
    [taskId]="selectedTaskId() || ''"
    (visibleChange)="handleVisibleChanged($event)"
  ></pfx-task-details-sidebar>
}
